// Aqui se centralizan los strings de las rutas
export class RouterNames {
    public static Login: string = 'Login';
    public static mainlayout: string = 'mainlayout';
    public static Home: string = 'Home';
    public static usuarios:string="usuarios";
    public static usuarioslista:string="usuarioslista";
    public static empresaslista:string="empresaslista";
    public static empresas:string="empresas";
    public static cerrar_session:string="cerrar_session";
    public static mi_perfil:string="mi_perfil";
    public static notificaciones:string="notificaciones";
    public static lostpwd:string="lostpwd";
    public static ayuntamientos:string="ayuntamientos";
    public static ayuntamientoslista:string="ayuntamientoslista";
    public static confirm_new_password:string="confirm_new_password";
    public static preguntas:string="preguntas";
    public static preguntaslista:string="preguntaslista";
    public static preguntasformulario:string="preguntasformulario";
    public static configuracion:string="configuracion";
    public static importaciones:string="importaciones";
    public static dashboards:string="dashboards";
    public static dashboardslista:string="dashboardslista";
    public static dashboardsformulario:string="dashboardsformulario";
    public static agrupaciones:string="agrupaciones";
    public static agrupacioneslista:string="agrupacioneslista";
    public static mapeador:string="mapeador";
    public static mapeadorlista:string="mapeadorlista";
    public static mapeadorformulario:string="mapeadorformulario";
    public static instalacion:string="instalacion";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";

}
